import uoy from "../assets/companies/uoy.jpeg";
import sei from "../assets/companies/sei.jpeg";
import samasa from "../assets/companies/samasa.jpeg";
import gel from "../assets/companies/gel.jpeg";
import persistent from "../assets/companies/persistent.jpeg";
import viavi from "../assets/projects/viavi_osc.mp4";
import eexapp from "../assets/projects/ee_xapp.mp4";

export default function RoadmapWithCompanies() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;800&display=swap');

        :root {
          --bg: #050505;
          --card-bg: #111111;
          --border: #222222;
          --accent: #f97316; /* Modern Orange */
          --accent-glow: rgba(249, 115, 22, 0.15);
          --text-main: #ffffff;
          --text-dim: #a1a1aa;
          --font-sans: 'Inter', sans-serif;
        }

        .page {
          max-width: 1100px;
          margin: 0 auto;
          padding: 60px 20px;
          color: var(--text-main);
          font-family: var(--font-sans);
          background-color: var(--bg);
        }

        header {
          margin-bottom: 50px;
        }

        .name-title {
          font-size: 2rem;
          font-weight: 800;
          letter-spacing: -1px;
          margin-bottom: 10px;
          background: linear-gradient(to bottom right, #fff, #71717a);
          -webkit-background-clip: text;
          -webkit-text-fill-color: var(--accent);
        }

        .header-sub {
          font-size: 1.1rem;
          line-height: 1.6;
        }

.h-section {
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: var(--accent);
  margin: 60px 0 32px;
  display: flex;
  align-items: center;
  gap: 20px;
  text-align: center;
}

/* Left Line: Fades from nothing TO the border color */
.h-section::before {
  content: "";
  height: 1px;
  flex-grow: 1;
  background: linear-gradient(to right, transparent, var(--border));
}

/* Right Line: Fades FROM the border color TO nothing */
.h-section::after {
  content: "";
  height: 1px;
  flex-grow: 1;
  background: linear-gradient(to right, var(--border), transparent);
}

        .grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 40px;
          align-items: start;
        }

        @media (min-width: 992px) {
          .grid { grid-template-columns: 300px 1fr; }
          .sticky { position: sticky; top: 40px; }
        }

        /* ===== COMPANY CARDS (BENTO STYLE) ===== */
        .tallCard { display: flex; flex-direction: column; gap: 16px; }
        
        .companyCard {
          background: var(--card-bg);
          border: 1px solid var(--border);
          border-radius: 16px;
          padding: 20px;
          transition: all 0.3s ease;
        }
        .companyCard:hover {
          border-color: var(--accent);
          box-shadow: 0 10px 30px -10px var(--accent-glow);
          transform: translateY(-2px);
        }

        .companyRow { display: flex; gap: 16px; align-items: flex-start; }
        .logoBox { 
          width: 44px; height: 44px; border-radius: 10px; 
          background: #fff; padding: 4px; overflow: hidden;
          flex-shrink: 0;
        }
        .logo { width: 100%; height: 100%; object-fit: contain; }
        
        .companyTitle { font-size: 14px; color: var(--text-dim); margin-bottom: 4px; }
        .companyRole { font-size: 16px; font-weight: 600; color: #fff; line-height: 1.2; }
        .companyPeriod { font-size: 12px; color: var(--text-dim); margin-top: 8px; font-weight: 400; }

        /* ===== SECTIONS / ACCORDIONS ===== */
        .section-wrapper { display: flex; flex-direction: column; gap: 12px; }

        details.section {
          background: var(--card-bg);
          border: 1px solid var(--border);
          border-radius: 16px;
          overflow: hidden;
          transition: border-color 0.3s;
        }

        details.section[open] {
          border-color: #333;
        }

        details.section > summary {
          list-style: none;
          cursor: pointer;
          padding: 20px 24px;
          font-weight: 600;
          font-size: 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        details.section > summary::after {
          content: "+";
          color: var(--text-dim);
          font-weight: 300;
          font-size: 24px;
          transition: transform 0.3s;
        }
        details.section[open] > summary::after {
          transform: rotate(45deg);
          color: var(--accent);
        }

        .sectionBody { padding: 0 24px 24px; }

        /* Tags / Items */
        .item-container { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; }

        .item, .itemChild {
          background: #1a1a1a;
          border: 1px solid var(--border);
          padding: 8px 16px;
          border-radius: 100px;
          font-size: 14px;
          color: #e4e4e7;
          transition: all 0.2s;
        }

        .item:hover, .itemChild:hover {
          background: #222;
          border-color: #444;
        }

        /* Interactive Video Items */
        details.item, details.itemChild {
          border-radius: 16px;
          width: 100%;
          padding: 0;
          background: #161616;
          margin-bottom: 8px;
        }

        details.item summary, details.itemChild summary {
          padding: 12px 16px;
          font-size: 14px;
        }

        .videoWrap {
          margin: 0 12px 12px;
          border-radius: 12px;
          overflow: hidden;
          aspect-ratio: 16/9;
          background: #000;
        }

        .videoWrap video, .videoWrap iframe {
          width: 100%; height: 100%; border: 0;
        }

        .group {
          margin-top: 16px;
          border-top: 1px solid var(--border);
          padding-top: 16px;
        }
        .group-label {
          font-size: 12px;
          text-transform: uppercase;
          color: var(--text-dim);
          letter-spacing: 1px;
          margin-bottom: 12px;
          display: block;
        }

   
        a:hover { text-decoration: underline; }
      `}</style>

      <div className="page">
        <header>
          <h1 className="name-title">Mohit Bidikar</h1>
          <div className="header-sub">
            Software Engineer with 8+ years of experience. <br />
            MSc & BEng in Computer Science. <br />
            Building 5G testbeds, xApps, Open RAN and cloud-native telecom
            systems. <br /> On Global Talent Visa.
          </div>
        </header>

        <div className="h-section">Telco Software</div>
        <div className="grid">
          <CompanyColumn companies={yorkCompanies} className="sticky" />
          <SectionsColumn sections={researchSections} />
        </div>

        <div className="h-section">Full Stack Applications</div>
        <div className="grid">
          <CompanyColumn companies={otherCompanies} className="sticky" />
          <SectionsColumn sections={stackSections} />
        </div>
      </div>
    </>
  );
}

function SectionsColumn({ sections }) {
  return (
    <div className="section-wrapper">
      {sections.map((sec) => (
        <details key={sec.title} open className="section">
          <summary>{sec.title}</summary>
          <div className="sectionBody">
            <div className="item-container">
              {sec.items.map((item, idx) =>
                item.children ? (
                  <div key={idx} className="group" style={{ width: "100%" }}>
                    <span className="group-label">{item.label}</span>
                    <div className="item-container">
                      {item.children.map((child, cidx) => (
                        <ContentItem key={cidx} item={child} isChild />
                      ))}
                    </div>
                  </div>
                ) : (
                  <ContentItem key={idx} item={item} />
                ),
              )}
            </div>
          </div>
        </details>
      ))}
    </div>
  );
}

function ContentItem({ item, isChild }) {
  if (item.video) {
    return (
      <details className={isChild ? "itemChild" : "item"} open={item.isOpen}>
        <summary>
          {item.label}{" "}
          <small style={{ opacity: 0.5, marginLeft: 8 }}>▶ Watch</small>
        </summary>
        <div className="videoWrap">
          <VideoEmbed url={item.video} title={item.label} />
        </div>
      </details>
    );
  }

  return (
    <span className={isChild ? "itemChild" : "item"}>
      {item.link ? (
        <a href={item.link} target="_blank" rel="noreferrer">
          {item.label}
        </a>
      ) : (
        item.label
      )}
    </span>
  );
}

function VideoEmbed({ url, title }) {
  const yt = getYouTubeID(url);
  return yt ? (
    <iframe
      src={`https://www.youtube-nocookie.com/embed/${yt}`}
      title={title}
      allowFullScreen
    />
  ) : (
    <video controls src={url} />
  );
}

function getYouTubeID(u) {
  try {
    const x = new URL(u);
    if (x.searchParams.get("v")) return x.searchParams.get("v");
    if (x.hostname.includes("youtu.be")) return x.pathname.slice(1);
    if (x.pathname.startsWith("/shorts/")) return x.pathname.split("/")[2];
  } catch {}
  return /^[\w-]{11}$/.test(u) ? u : null;
}

function CompanyColumn({ companies, className }) {
  return (
    <aside className={className}>
      <div className="tallCard">
        {companies.map((c) => (
          <div key={c.name} className="companyCard">
            <div className="companyRow">
              <div className="logoBox">
                <img className="logo" src={c.logo} alt={c.name} />
              </div>
              <div>
                <div className="companyTitle">{c.name}</div>
                <div className="companyRole">{c.role}</div>
                <div className="companyPeriod">{c.period}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}

// ... Keep your researchSections, stackSections, etc. data constants same as before
const researchSections = [
  {
    title: "xApps",
    items: [
      { label: "Energy efficiency", video: eexapp, isOpen: true },
      {
        label: "PRB allocation",
        video: "https://www.youtube.com/watch?v=iogV3BOLQLQ",
        isOpen: true,
      },
    ],
  },
  {
    title: "5G Core",
    items: [{ label: "Open5GS" }],
  },
  {
    title: "RIC integration",
    items: [
      { label: "OSC RIC (VIAVI)", video: viavi, isOpen: true },
      {
        label: "OSC RIC (srsRAN)",
        video: "https://www.youtube.com/watch?v=iogV3BOLQLQ",
      },
    ],
  },
  {
    title: "5G Testbeds",
    items: [
      {
        label: "srsRAN Split 8",
        children: [
          {
            label: "srs UE",
            video: "https://www.youtube.com/watch?v=xW7LMHVnIJk",
            isOpen: true,
          },
          {
            label: "Pixel and Robot with Quectel Modem",
            video: "https://www.youtube.com/watch?v=iogV3BOLQLQ",
          },
        ],
      },
      { label: "srsRAN Split 7.2" },
    ],
  },
  {
    title: "Simulations",
    items: [
      { label: "VIAVI AI RSG" },
      { label: "srsRAN ZMQ" },
      { label: "NVIDIA Omniverse" },
    ],
  },
  {
    title: "Papers",
    items: [
      {
        label: "Cloud Services Research For IoT Applications",
        link: "https://www.researchgate.net/publication/393017684_CLOUD_SERVICES_AND_PLATFORMS_RESEARCH_FOR_INTERNET_OF_THINGS_APPLICATIONS_DEPLOYMENT",
      },
      {
        label: "Towards Resilient 6G O-RAN",
        link: "https://www.researchgate.net/publication/386395641_Towards_Resilient_6G_O-RAN_An_Energy-Efficient_URLLC_Resource_Allocation_Framework",
      },
    ],
  },
];

const stackSections = [
  {
    title: "Front End",
    items: [{ label: "React" }, { label: "Grafana" }],
  },
  {
    title: "Communication",
    items: [
      { label: "GraphQL" },
      { label: "WebSockets" },
      { label: "UDP" },
      { label: "REST APIs" },
    ],
  },
  {
    title: "CI / CD and Infrastructure",
    items: [
      { label: "GitHub Actions" },
      { label: "Docker" },
      { label: "Kubernetes" },
      { label: "AWS" },
    ],
  },
  {
    title: "Databases",
    items: [{ label: "SQL" }, { label: "NoSQL" }],
  },
  {
    title: "Languages",
    items: [{ label: "Python" }, { label: "Java" }, { label: "JavaScript" }],
  },
];

const yorkCompanies = [
  {
    name: "University of York",
    role: "Research Software Engineer",
    logo: uoy,
    period: "May 2024 – Present",
  },
];

const otherCompanies = [
  {
    name: "Stockholm Environment Institute",
    role: "Frontend Developer",
    logo: sei,
    period: "Apr 2023 – Oct 2023",
  },
  {
    name: "Samasa Innovations",
    role: "Senior Software Developer",
    logo: samasa,
    period: "Dec 2020 – Aug 2022",
  },
  {
    name: "Goa Electronics Ltd",
    role: "Software Engineer",
    logo: gel,
    period: "Nov 2018 – Dec 2020",
  },
  {
    name: "Persistent",
    role: "Software Development Intern",
    logo: persistent,
    period: "Jan 2016 – Feb 2016",
  },
];
